<template>
  <report-data-provider :requiredReports="requiredReports" v-model="reports" v-slot:default="{ loading }">
    <panel prompt="Среди закрытых на сегодня">
      <template #title>
        <div>
          <font-awesome-icon icon="exclamation-triangle" class="gold mr2"/>
          <span>Завершенные процедуры требующие внимания</span>
        </div>
      </template>
      <template #content>
        <div class="layout">
          <text-card v-for="(measure, index) in getStats(loading)" :key="index" :loading="loading">
            <template #title>{{ measure.title }}</template>
            <template #value>{{ measure.value }}</template>
            <template #unit>{{ measure.unit }}</template>
          </text-card>
        </div>
      </template>
    </panel>
  </report-data-provider>
</template>

<script>
import ReportDataProvider from '@/components/dashboard/ReportDataProvider.vue'
import Panel from '@/components/dashboard/widgets/templates/Panel.vue'
import TextCard from '@/components/dashboard/widgets/templates/TextCard.vue'
import { pluralForm } from '@/utils/pluralForms'

export default {
  components: {
    ReportDataProvider,
    Panel,
    TextCard
  },
  data () {
    return {
      requiredReports: [
        'soleWinnerParticipant',
        'notTheBestWinnerForThePrice',
        'failedWithMoreThanOneParticipant',
        'ownerCancelTheTender'
      ],
      reports: []
    }
  },
  computed: {
    stats () {
      return [
        {
          title: 'Торги с победителем – единственным участником',
          value: this.reports.soleWinnerParticipant.withWinnerOneParticipantAvg, // TODO: почему AVG? Скорее тут имеется общее кол-во
          unit: pluralForm(this.reports.soleWinnerParticipant.withWinnerOneParticipantAvg, ['конкурс', 'конкурса', 'конкурсов'])
        },
        {
          title: 'Несостоявшиеся торги, в которых более 1 предложения',
          value: this.reports.failedWithMoreThanOneParticipant.failedAvg,
          unit: pluralForm(this.reports.failedWithMoreThanOneParticipant.failedAvg, ['конкурс', 'конкурса', 'конкурсов'])
        },
        {
          title: 'Торги с победителем, предложившим не наименьшую цену',
          value: this.reports.notTheBestWinnerForThePrice.withWinnerNotMinPriceAvg,
          unit: pluralForm(this.reports.notTheBestWinnerForThePrice.withWinnerNotMinPriceAvg, ['конкурс', 'конкурса', 'конкурсов'])
        },
        {
          title: 'Отказ организатора от продолжения торгов',
          value: this.reports.ownerCancelTheTender.canceledAvg,
          unit: pluralForm(this.reports.ownerCancelTheTender.canceledAvg, ['конкурс', 'конкурса', 'конкурсов'])
        }
      ]
    }
  },
  methods: {
    getStats (loading) {
      return loading ? [{}, {}, {}, {}] : this.stats
    }
  }
}
</script>

<style lang="scss" scoped>
.layout {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  grid-gap: .5rem;
  border-radius: .25rem;
}
@media only screen and (min-width: 60em) {
  .layout {
    grid-gap: .85rem;
    grid-template-columns: repeat(auto-fill, minmax(450px, 1fr));
  }
}
</style>
